<script setup lang="ts">
import { ref, type PropType } from 'vue';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import { type FormField } from '@/models';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();

const props = defineProps({
  field: {
    type: Object as PropType<FormField>,
    required: true
  },
  previewMode: {
    type: Boolean
  }
});

const localField = ref<FormField>(props.field);
</script>

<template>
    <div class="item-root">
      <Select v-model="localField.choiceValue"
        :placeholder="$t('select')"
        optionLabel="label"
        v-if="localField.options.maximumChoicesCount == 1"
        :options="localField.options.choices?.filter(choice => !choice.archived)"
        showClear
        :disabled="previewMode"
        class="select-input"/>
      <MultiSelect v-model="localField.choiceValue"
        :options="localField.options.choices?.filter(choice => !choice.archived)"
        :placeholder="$t('select')"
        display="chip"
        v-if="localField.options.maximumChoicesCount != 1"
        optionLabel="label"
        :disabled="previewMode"
        class="select-input"/>
    </div>
</template>

<style scoped lang="scss">
.select-input {
  width: 100%;
}
</style>
